/* MugOnAMug cart approval gate.
 *
 * The checkbox writes a `design_approved` cart attribute, so the record rides
 * along to the order and the state survives Dawn re-rendering the cart. We do
 * not stamp a time here: a browser clock is the customer's own, in their
 * timezone, and trivially changed. Shopify stamps the order itself, and that
 * is the timestamp worth relying on.
 *
 * Until the box is ticked, checkout is blocked and the express buttons are
 * hidden. Express is the whole reason this matters: Shop Pay would otherwise
 * carry someone past the approval in one tap.
 */
(function () {
  var SELECTOR = '[data-mug-approve]';

  function approved() {
    var box = document.querySelector(SELECTOR);
    return !!(box && box.checked);
  }

  function sync() {
    var ok = approved();

    document.querySelectorAll('[data-mug-approve-wrap]').forEach(function (wrap) {
      wrap.classList.toggle('mug-approve--done', ok);
    });

    // Checkout buttons: disabled outright, so the state is obvious and the
    // form cannot submit even without JS interception.
    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      btn.disabled = !ok;
      btn.classList.toggle('mug-blocked', !ok);
    });

    // Express buttons come from Shopify as opaque markup, so we hide the
    // container rather than trying to disable what is inside it.
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons')
      .forEach(function (el) {
        el.hidden = !ok;
      });

    if (ok) {
      document.querySelectorAll('[data-mug-approve-nudge]').forEach(function (n) {
        n.hidden = true;
      });
    }
  }

  function save(isOn) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { design_approved: isOn ? 'yes' : '' } })
    }).catch(function () {
      /* A failed write must not strand the customer: the checkbox still
         governs this page, and an unrecorded attribute is better than a
         cart that cannot check out. */
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches(SELECTOR)) return;
    var isOn = e.target.checked;
    // Keep both copies in step when the drawer and the page are both present.
    document.querySelectorAll(SELECTOR).forEach(function (box) {
      box.checked = isOn;
    });
    sync();
    save(isOn);
  });

  // Someone who clicks a disabled button gets told why rather than nothing.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[name="checkout"]');
    if (!btn || approved()) return;
    e.preventDefault();
    document.querySelectorAll('[data-mug-approve-nudge]').forEach(function (n) {
      n.hidden = false;
    });
    var box = document.querySelector(SELECTOR);
    if (box) box.focus();
  }, true);

  // Dawn swaps the cart markup wholesale after a quantity change or a
  // removal, which drops whatever state we set. Re-apply when that happens.
  var pending;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(sync, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
